/**
 * Media assets used across the site.
 * Store all local/uploaded image URLs here so they are easy to manage.
 */

/** Profile photo used on the About page */
import profilePic from './ProfilePicture.png';
import therapistLogo from './TherapistLogo.png';

export const ABOUT_PROFILE_PHOTO = profilePic;

export const THERAPIST_LOGO = therapistLogo;